import { ToursEnum } from './../../../enums/tour/tours.enum';
import { LocalStorageEnum } from './../../../enums/utils/local-storage.enum';
import { PanelUtilitiesActions } from 'src/app/models/panel-utilities';
import { firstValueFrom } from 'rxjs';
import Step from 'shepherd.js/src/types/step';
import {TourSteps} from './interface/tour-steps.interface';


export const workSchedulesOnlyExpertWithoutPermisionEditStep: (tourSteps: TourSteps) => Step.StepOptions[] =
({steps, buttons, services, cb}: TourSteps): Step.StepOptions[] => {
  return [
    {
      ...steps.default,
      id: 'workSchedules1',
      title: 'Horarios',
      text: `Ingresa al módulo "Horarios".`,
      attachTo: {
        element: '.panel-item-1',    // @ts-ignore
        on: 'bottom'
      },
      advanceOn: {
        selector: '.panel-item-1',
        event: 'click',
      },
      canClickTarget: true,
      buttons: [{...buttons.cancel}],
      beforeShowPromise: () => {
        return new Promise((resolve): void => {
          services.utilitiesService.existElementInDom().byClassName('panel-item-1').subscribe({
            next: async () => await firstValueFrom(services.store.dispatch(new  PanelUtilitiesActions.SetIsVisible(false))),
            complete: async () => {
              await firstValueFrom(services.store.dispatch(new  PanelUtilitiesActions.SetIsVisible(true)));
              resolve(true);
            }
          });
        });
      }
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep3',
      title: 'Cierra el panel lateral',
      text: `Haz clic para ocultar el panel, de esa forma podrás tener mejor visibilidad de los horarios.`,
      attachTo: {
        element: '.icon-hide-menu',
        on: 'bottom'
      },
      advanceOn: {
        selector: '.icon-hide-menu',
        event: 'click'
      },
      buttons: [{...buttons.cancel}],
    },
    {
      // work-schedules
      ...steps.default,
      id: 'workSchedules3',
      title: 'Horario',
      text: 'Esta sección muestra los horarios de atención a los pacientes. Sí deseas definir tus propios horarios necesitas ponerte en contacto con el administrador de la clínica. En seguida te mostraremos las secciones que conforman un horario.',
      canClickTarget: false,
      buttons: [
        {
          text: 'Entendido',
          // tslint:disable-next-line:typedef
          action(): void { this.next(); },
        },
        {...buttons.cancel},
      ]
    },
    {
      // schedules-items
      ...steps.default,
      id: 'workSchedules11',
      title: 'Días y horas disponibles del grupo',
      text: 'Esta sección muestra los días y horas de trabajo. Recuerda que estos valores los ha definido la clínica.',
      canClickTarget: false,
      attachTo: {
        element: '.schedules-items',
        on: 'right',
      },
      scrollTo: undefined,
    },
    {
      // schedules-exceptions
      ...steps.default,
      id: 'workSchedules17',
      title: 'Excepciones',
      text: 'Esta sección nos permitirá agregar excepciones, por ejemplo agregar días festivos o un horario en específico.',
      canClickTarget: false,
      attachTo: {
        element: '.schedules-exceptions',
        on: 'left',
      },
      scrollTo: undefined,
      buttons: [
        {
          text: 'Entendido',
          // tslint:disable-next-line:typedef
          action()  {
            cb('addException');
            if (services.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.EXPERT_SCHEDULES) {
              // Si viene de la página de tours, le da la opción de mantenerse aquí o ir al listado de tours
              this.next();
            } else {
              // Si está haciendo el tour como usuario nuevo, completa este tour y comienza el tour de crear paciente
              this.complete();
            }
          },
        },
        {...buttons.cancel},
      ]
    },
    {
      ...steps.default,
      id: 'workSchedules29',
      title: 'Tour finalizado',
      // text: '¡Muy bien!. Ya conoces la forma de registrar sucursales, ahora solo te queda registrarlas.',
      text: '¡Muy bien!. Has finalizado el tour de "Registrar horario".',
      canClickTarget: false,
      buttons: [
        {
          // tslint:disable-next-line:typedef
          action(): void {
            cb('goToTours');
          },
          text: 'Ir al listado de tours',
          classes: 'shepherd-button shepherd-button-secondary',
        },
        {
          // tslint:disable-next-line:typedef
          action(): void {
            cb('keepMeHere');
          },
          text: 'Mantenerme aquí'
        },
        {...buttons.cancel}
      ]
    }
  ];
};
